import type { FetchRequestError } from "@lib/errors";

/**
 * The machine-readable denial code from the canonical Braze::API error envelope
 * (`{errors: [{status_code, error_code, message, ...}]}`), or undefined for any other response
 * shape. Legacy endpoints never emit this envelope, so branching on the returned code cannot
 * change their modal treatment. Codes are defined in
 * `shared_code/domains/api/public/braze/api/errors.rb` (`Braze::API::Errors::DenialCodes`);
 * per the API standards, the frontend renders localized copy from the code — the envelope's
 * `message` is only an English fallback.
 */
export const getBrazeApiDenialCode = (error: FetchRequestError): string | undefined => {
  const errors = error.responseJson?.errors;
  if (!Array.isArray(errors)) {
    return undefined;
  }
  const code = errors[0]?.error_code;
  return typeof code === "string" ? code : undefined;
};
